import "./Home.css";
import { InviteForm, SiteNav, SiteFooter, useSeo } from "./_site";

/* Dedicated public SMS opt-in page for A2P 10DLC carrier verification.
   Same real waitlist pipeline + shared form logic as every other invite form — no login,
   no modal, no redirect. The phone field and SMS consent control live in one real <form>. */
export default function SmsOptIn() {
  useSeo(
    "Request access to Remy",
    "Enter your information to request access to Remy. Text-message enrollment is optional."
  );

  return (
    <div className="remy-home" data-testid="sms-opt-in-page">
      <SiteNav />
      <section className="rh-section rh-optin">
        <div className="rh-wrap rh-optin__wrap">
          <h1 className="rh-optin__title" data-testid="optin-heading">Request access to Remy</h1>
          <p className="rh-optin__lead" data-testid="optin-lead">
            Enter your information to request access. Text-message enrollment is optional.
          </p>
          <div className="rh-optin__card">
            <InviteForm idPrefix="optin" variant="card" source="sms_opt_in" labeled bareIds />
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
